import { FC, PropsWithChildren } from 'react';
import { ApolloProvider } from '@apollo/client';

import { CollectionsContainer } from '@/features/collections/CollectionsContainer';
import { useAppI18n } from '@/shared/hooks/app/useAppI18n';
import { NoticesProvider } from '@/shared/providers/notices';
import { useApolloClient } from '@/shared/services/apollo';
import { ModalsContainer } from '@/widgets/modals/ModalsContainer';

import { useAppErrors } from '../hooks/useAppErrors';
import { DebugTools } from '../layouts/DebugTools';
import { AuthProvider } from '../providers/AuthProvider';
import { FormDrawerProvider } from '../providers/FormDrawerProvider';
import { ThemeProvider } from '../providers/ThemeProvider';

export const AppContainerExported: FC<PropsWithChildren> = ({ children }) => {
  const apolloClient = useApolloClient();
  const i18nReady = useAppI18n();

  useAppErrors();

  if (!apolloClient) return <div>ApolloClient is not initialized</div>;
  if (!i18nReady) return null;

  return (
    <ApolloProvider client={apolloClient}>
      <ThemeProvider>
        <NoticesProvider>
          <CollectionsContainer />
          {/* <SocketProvider> */}
          <AuthProvider>
            <FormDrawerProvider>
              {children}
              <ModalsContainer />
              {/* <SmartImportContainer /> */}
            </FormDrawerProvider>
          </AuthProvider>
          {/* </SocketProvider> */}
        </NoticesProvider>
        <DebugTools />
      </ThemeProvider>
    </ApolloProvider>
  );
};
